import Vue from 'vue';
import store from '@/store';
import request from '@/utils/request';
import { baseURL, tokenName } from '@/config/net.config';
import { sysPlatformType } from '@/config/edition.config';
import { hasPermission } from '@/utils/permission';

import ElementUI from 'element-ui';
import RockWorkflow from '@workflow/workflow-components-pc';
import '../assets/styles/element-variables.scss';

const elOptions = {
  size: 'small',
};

Vue.use(ElementUI, elOptions).use(RockWorkflow, {
  ...elOptions,
  store,
  baseURL,
  request,
  systemType: sysPlatformType,

  userType: 1,
  getUserInfo: function () {
    return store.getters.userInfo || null;
  },
  getUserToken: function () {
    return localStorage.getItem(tokenName) || '';
  },
  getUserRole: function () {
    if (store.getters.currentRole?.postId) {
      return store.getters.currentRole;
    } else {
      return {
        postId: '',
        postName: '',
      };
    }
  },
  hasUserPerm: hasPermission,
});
